import Info from "gatsby-theme-dettol/src/components/common/MediaInfoBox/Info/Info"

import "./InfoOverride.scss"

export default Info